<template>
  <section class="subexam-print">
    <v-container>
      <header>
        <img src="@/assets/img/print-logo.png" alt="URC">
        <span>{{subexam.hat}}</span>
        <v-heading level="h3">{{subexam.title}}</v-heading>
      </header>
      <body-text v-html="subexam.details"></body-text>
      <footer>
        <div class="address" v-for="(location, index) in locations" :key="index">
          <svg :class="location.color"
            width="64px" height="64px"
            viewBox="0 0 64 64"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <path d="M43,15 C43,17.762345 40.762528,20 37.9998821,20 C35.237472,20 33,17.762345 33,15 C33,12.2374192 35.237472,10 37.9998821,10 C40.762528,10 43,12.2374192 43,15 M23,16.1117511 C23,19.0624674 23.7493161,21.805906 25.0798091,24.1740964 L38.5,44 L51.9333496,24.1740964 C53.2380125,21.805906 54,19.0624674 54,16.1117511 C54,7.20833195 47.0638913,-2.55795385e-13 38.5,-2.55795385e-13 C29.9363523,-2.55795385e-13 23,7.20833195 23,16.1117511" id="Fill-1" fill="#CCCCCC"></path>
            <path d="M31.9998716,22 C29.7939223,22 28,20.2058786 28,18 C28,15.7941214 29.7939223,14 31.9998716,14 C34.2060777,14 36,15.7941214 36,18 C36,20.2058786 34.2060777,22 31.9998716,22 Z M31.9998796,24 C35.3090617,24 38,21.3090077 38,18 C38,14.6909923 35.3090617,12 31.9998796,12 C28.6911791,12 26,14.6909923 26,18 C26,21.3090077 28.6911791,24 31.9998796,24 Z" id="Fill-5" fill="#1D1B4B"></path>
            <path d="M47,18.8010374 C47,21.5423197 46.322061,24.2504959 45.036422,26.644285 L32.0014383,46 L18.9710094,26.6319608 C17.6810554,24.2792523 17,21.5742176 17,18.8010374 C17,10.0885733 23.7290481,3 32,3 C40.2709519,3 47,10.0885733 47,18.8010374 M14,18.6275673 C14,21.910994 14.8305192,25.1260819 16.4003558,27.9235974 L31.9985447,51 L47.4992252,28.1076989 L47.6239001,27.9053575 C49.1772427,25.0796309 50,21.8711094 50,18.6275673 C50,8.35606686 41.9257233,2.84217094e-13 32,2.84217094e-13 C22.0742767,2.84217094e-13 14,8.35606686 14,18.6275673" id="Fill-7" fill="#1D1B4B"></path>
          </svg>
          <v-heading level="h5">{{location.title}}</v-heading>
          <p>{{location.address}}</p>
        </div>
        <div class="phones">
          <phone-number />
          <phone-number icon="whatsapp" />
        </div>
      </footer>
    </v-container>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Container from '@/components/layout/Container.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import BodyText from '@/components/uikit/text/BodyText.vue';
import PhoneNumber from '@/components/PhoneNumber.vue';

export default {
  name: 'SubexamPrint',
  components: {
    'v-container': Container,
    'v-heading': Heading,
    'body-text': BodyText,
    'phone-number': PhoneNumber,
  },
  props: {
    subexam: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      locations,
    };
  },
};
</script>
<style lang="scss">
@media print {
  .header,
  .footer {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
$component: '.subexam-print';
#{$component} {
  padding: $gutter-xxl 0;
  display: none;
  @media print {
    display: block;
  }
  .container {
    padding: 0 8.333%;
  }
  header {
    display: grid;
    grid-template-columns: 55px auto;
    grid-template-rows: auto auto;
    grid-gap: 0 $gutter-xl;
    margin-bottom: $gutter-xxxl;
    img {
      grid-column: 1 / 2;
      grid-row: 1 / 3;
    }
    span {
      grid-column: 2 / 3;
      grid-row: 1 / 2;
    }
    h3 {
      grid-column: 2 / 3;
      grid-row: 2 / 3;
      margin: 0;
      color: $color-a;
    }
  }
  .body-text {
    margin-bottom: $section-gutter;
    /deep/ p {
      font-size: $font-size-l;
      color: $color-sys-c;
    }
  }
  footer {
    text-align: center;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    grid-gap: $gutter-xxl;
    margin-bottom: $gutter-xxl;
    .phones {
      grid-row: 2 / 3;
      grid-column: 1 / 3;
      padding-top: $gutter-xxl;
      border-top: 1px solid $color-sys-h;
    }
    .phone,
    .address {
      margin: 0 $gutter-l;
    }
    .address {
      padding: 0 6px;
      font-size: $font-size-xl;
      color: $color-sys-e;
      svg {
        display: inline-block;
        height: 50px;
        margin-bottom: $gutter-l;
        &.color-a path:nth-child(1) {
          fill: $color-a;
        }
        &.color-c path:nth-child(1) {
          fill: $color-c;
        }
      }
      &:nth-child(1) .heading {
        color: $color-a;
      }
      &:nth-child(2) .heading {
        color: $color-c;
      }
    }
    .phones {
    }
  }
}
</style>
